var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "t-player__controller" }, [
    _c(
      "div",
      {
        staticClass: "t-player__slider",
        on: {
          click: function($event) {
            return _vm.seek($event)
          }
        }
      },
      [
        _c("div", {
          staticClass: "t-player__knob",
          style: { width: _vm.width }
        }),
        _vm._v(" "),
        !_vm.$isEmpty(_vm.quickJumpSteps)
          ? _c(
              "div",
              { staticClass: "t-player__steps" },
              _vm._l(_vm.quickJumpSteps, function(i, index) {
                return _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: {
                          content: _vm.isChapter
                            ? i.label
                            : _vm.$msToTime(i.startTime * 1000),
                          offset: 8,
                          delay: { show: 100 }
                        },
                        expression:
                          "{\n          content: isChapter ? i.label : $msToTime(i.startTime * 1000),\n          offset: 8,\n          delay: { show: 100 }\n        }"
                      }
                    ],
                    key: i.id,
                    staticClass: "t-player__step",
                    style: { left: _vm.step(i.startTime) }
                  },
                  [!_vm.isChapter ? [_vm._v(_vm._s(index + 1))] : _vm._e()],
                  2
                )
              }),
              0
            )
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "t-player__controls" }, [
      _c(
        "div",
        { staticClass: "t-player__controls-main" },
        [
          _c(
            "transition",
            { attrs: { name: "fade", mode: "out-in" } },
            [
              _vm.isPaused || _vm.isEnded
                ? _c(
                    "t-button",
                    {
                      key: "play",
                      staticClass: "t-player__control",
                      attrs: { variant: "action" },
                      on: {
                        click: function($event) {
                          return _vm.play()
                        }
                      }
                    },
                    [_c("i", { staticClass: "fas fa-play t-fs--body" })]
                  )
                : _c(
                    "t-button",
                    {
                      key: "pause",
                      staticClass: "t-player__control",
                      attrs: { variant: "action" },
                      on: {
                        click: function($event) {
                          return _vm.pause()
                        }
                      }
                    },
                    [_c("i", { staticClass: "fas fa-pause t-fs--body" })]
                  )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "t-player__volume" },
            [
              _c(
                "transition",
                { attrs: { name: "fade", mode: "out-in" } },
                [
                  _vm.isMuted
                    ? _c(
                        "t-button",
                        {
                          key: "volume-mute",
                          staticClass: "t-player__control",
                          attrs: { variant: "action" },
                          on: { click: _vm.unmute }
                        },
                        [
                          _c("i", {
                            staticClass: "fas fa-volume-mute fa-fw t-fs--h5"
                          })
                        ]
                      )
                    : _vm.volumelow
                    ? _c(
                        "t-button",
                        {
                          key: "volume-down",
                          staticClass: "t-player__control",
                          attrs: { variant: "action" },
                          on: { click: _vm.mute }
                        },
                        [
                          _c("i", {
                            staticClass: "fas fa-volume-down fa-fw t-fs--h5"
                          })
                        ]
                      )
                    : _c(
                        "t-button",
                        {
                          key: "volume-up",
                          staticClass: "t-player__control",
                          attrs: { variant: "action" },
                          on: { click: _vm.mute }
                        },
                        [_c("i", { staticClass: "fas fa-volume-up fa-fw" })]
                      )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "t-player__control t-player__range" },
                [
                  _c("t-input", {
                    attrs: {
                      type: "range",
                      variant: "range",
                      max: 1,
                      min: 0,
                      step: 0.01
                    },
                    model: {
                      value: _vm.volume,
                      callback: function($$v) {
                        _vm.volume = $$v
                      },
                      expression: "volume"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "t-player__control" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.formattedCurrentTime) +
                " /\n        " +
                _vm._s(_vm.formattedDuration) +
                "\n      "
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      !_vm.simple
        ? _c(
            "div",
            { staticClass: "t-player__controls-aside" },
            [
              _c(
                "div",
                { staticClass: "t-player__subtitle-control t-mar--r-xs" },
                [
                  !_vm.$isEmpty(_vm.subtitleTracks)
                    ? _c(
                        "t-button",
                        {
                          staticClass: "t-player__control t-mar--r-no",
                          attrs: { variant: "action" },
                          on: {
                            click: function($event) {
                              _vm.subtitleTracks.length > 1 && !_vm.$isMobile
                                ? _vm.showSubtitleTrackOptions()
                                : _vm.toggleCaption()
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "fa-closed-captioning fa-fw t-fs--h4",
                            class: [
                              { far: !_vm.subtitleLanguage },
                              { fas: _vm.subtitleLanguage }
                            ]
                          })
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "transition",
                    { attrs: { name: "fade", mode: "out-in" } },
                    [
                      _vm.showPopover
                        ? _c(
                            "div",
                            {
                              key: "popover",
                              staticClass:
                                "t-popover t-popover--top t-popover--center"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "t-popover__list" },
                                [
                                  _vm._l(_vm.subtitleTracks, function(s) {
                                    return _c(
                                      "div",
                                      {
                                        key: s.id,
                                        staticClass:
                                          "t-popover__item t-cursor--pointer",
                                        class: {
                                          "t-popover__item--active":
                                            _vm.subtitleLanguage == s.lang
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.setSubtitle(s)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(s.name) +
                                            "\n              "
                                        )
                                      ]
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      key: "off",
                                      staticClass:
                                        "t-popover__item t-cursor--pointer",
                                      class: {
                                        "t-popover__item--active": !_vm.subtitleLanguage
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.setSubtitle("")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("generic.text.off")) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ],
                                2
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "t-button",
                {
                  staticClass: "t-player__control",
                  attrs: { variant: "action" },
                  on: {
                    click: function($event) {
                      return _vm.setPlaybackSpeed()
                    }
                  }
                },
                [_vm._v("\n        " + _vm._s(_vm.playbackRate) + "×\n      ")]
              ),
              _vm._v(" "),
              _vm.slideModeEnabled
                ? _c(
                    "t-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: {
                            content: _vm.$t("generic.button.slideshow"),
                            offset: 8
                          },
                          expression:
                            "{\n          content: $t('generic.button.slideshow'),\n          offset: 8\n        }"
                        }
                      ],
                      staticClass: "t-player__control",
                      attrs: { variant: "action" },
                      on: {
                        click: function($event) {
                          return _vm.enterSlideMode()
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("@/lib/assets/images/icons/slideshow-24px.svg"),
                          height: "20px"
                        }
                      })
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pipEnabled
                ? _c(
                    "t-button",
                    {
                      staticClass: "t-player__control",
                      attrs: { variant: "action" },
                      on: {
                        click: function($event) {
                          return _vm.togglePip()
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("@/lib/assets/images/icons/picture_in_picture_alt-white-24dp.svg"),
                          height: "20px"
                        }
                      })
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.removeTrainnBranding
                ? _c(
                    "a",
                    {
                      staticClass: "t-player__control",
                      attrs: { href: "https://trainn.co/", target: "_blank" }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("@/lib/assets/images/trainn-text.svg"),
                          height: "14px"
                        }
                      })
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "transition",
                { attrs: { name: "fade", mode: "out-in" } },
                [
                  !_vm.isFullScreen
                    ? _c(
                        "t-button",
                        {
                          staticClass: "t-player__control",
                          attrs: { variant: "action" },
                          on: {
                            click: function($event) {
                              return _vm.enterFullScreen()
                            }
                          }
                        },
                        [_c("i", { staticClass: "fas fa-expand" })]
                      )
                    : _c(
                        "t-button",
                        {
                          staticClass: "t-player__control",
                          attrs: { variant: "action" },
                          on: {
                            click: function($event) {
                              return _vm.exitFullScreen()
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("@/lib/assets/images/icons/fullscreen_exit-white.svg"),
                              height: "24px"
                            }
                          })
                        ]
                      )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }